import { DTOCodeScanListItem } from "../design-systems/code-scan";
import { DTOForgeProjectContextV2 } from "../forge/project-context-v2";
import z from "zod";
export const DTOForgeProjectCreated = z.object({
    type: z.literal("ProjectCreated"),
    data: z.object({ id: z.string() }),
});
export const DTOForgeProjectUpdated = z.object({
    type: z.literal("ProjectUpdated"),
    data: z.object({ id: z.string() }),
});
export const DTOForgeProjectContextCreated = z.object({
    type: z.literal("ProjectContextCreated"),
    data: DTOForgeProjectContextV2,
});
export const DTOForgeProjectContextUpdated = z.object({
    type: z.literal("ProjectContextUpdated"),
    data: DTOForgeProjectContextV2,
});
export const DTOForgeProjectContextDeleted = z.object({
    type: z.literal("ProjectContextDeleted"),
    data: DTOForgeProjectContextV2.pick({ id: true }),
});
export const DTOSandboxTemplateVersionCreated = z.object({
    type: z.literal("SandboxTemplateVersionCreated"),
    data: z.object({
        templateId: z.string(),
        version: z.string(),
        designSystemId: z.string(),
    }),
});
export const DTOSandboxTemplateBuildCreated = z.object({
    type: z.literal("SandboxTemplateBuildCreated"),
    data: z.object({
        buildId: z.string(),
        templateId: z.string().optional(),
    }),
});
export const DTOSandboxTemplateBuildFinished = z.object({
    type: z.literal("SandboxTemplateBuildFinished"),
    data: z.object({
        buildId: z.string(),
        templateId: z.string().optional(),
    }),
});
export const DTOCodeScanFinished = z.object({
    type: z.literal("CodeScanFinished"),
    data: DTOCodeScanListItem,
});
export const DTODataChangedDataType = z.enum([
    "documentation",
    "token",
    "tokenGroup",
    "tokenTheme",
    "tokenProperty",
    "tokenPropertyValue",
    "component",
    "componentProperty",
    "componentPropertyValue",
    "designComponent",
    "asset",
    "designSource",
    "codeComponent",
    "automation",
    "context",
    "feedback",
    "resource",
    "skill",
    "knowledge-item",
]);
export const DTODataChanged = z.object({
    type: z.literal("DataChanged"),
    data: z.object({
        wsId: z.string(),
        dsId: z.string().optional(),
        dataType: DTODataChangedDataType,
    }),
});
export const DTOWorkspaceRoomEvent = z.discriminatedUnion("type", [
    DTOForgeProjectUpdated,
    DTOForgeProjectCreated,
    DTOForgeProjectContextCreated,
    DTOForgeProjectContextUpdated,
    DTOForgeProjectContextDeleted,
    DTOSandboxTemplateVersionCreated,
    DTOSandboxTemplateBuildCreated,
    DTOSandboxTemplateBuildFinished,
    DTOCodeScanFinished,
    DTODataChanged,
]);
